import React from 'react';

const ChartIcon: React.FC<{ className?: string }> = ({ className }) => (
    <svg
        className={className}
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M16.6667 17.5C15.7458 17.5 15 16.7542 15 15.8333V4.16667C15 3.24583 15.7458 2.5 16.6667 2.5C17.5875 2.5 18.3333 3.24583 18.3333 4.16667V15.8333C18.3333 16.7542 17.5875 17.5 16.6667 17.5Z"
            stroke="#B3BAC3"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M3.33334 17.5001C2.41251 17.5001 1.66667 16.7543 1.66667 15.8335V8.90348C1.66667 7.98265 2.41251 7.23682 3.33334 7.23682C4.25417 7.23682 5.00001 7.98265 5.00001 8.90348V15.8335C5.00001 16.7543 4.25417 17.5001 3.33334 17.5001Z"
            stroke="#B3BAC3"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M10 17.4998C9.07918 17.4998 8.33334 16.754 8.33334 15.8331V13.6398C8.33334 12.719 9.07918 11.9731 10 11.9731C10.9208 11.9731 11.6667 12.719 11.6667 13.6398V15.8331C11.6667 16.754 10.9208 17.4998 10 17.4998Z"
            stroke="#B3BAC3"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default ChartIcon;
